<template lang="pug">
  div
    el-row
      el-col
        pesquisa(
          placeHolder = "Informe o nome da Gleba ou nº do Processo",
          @search="handlePesquisa"
          @resetSearch="resetPesquisa"
          :cardStyle="{margin:'0px 0px 10px 0px', 'border-radius':'12px'}"
        )
    el-card.card-container(shadow="hover")
      app-divider-refresh-button(
        label="Listagem de Processos",
        @click="getProcessosCadastrados",
        :hasButton="true"
        content="Atualizar processos"
      )
      table-generica(
        :colunas="colunas",
        :botoesAcao="botoesAcao",
        :sortChanged='sortChanged',
        :dados='processosCadastrados'
        )
      app-paginacao(
        :total="totalCadastros"
        :pagina="pagina",
        @changePage="changePage"
      )
</template>

<script>
import { mapActions } from 'vuex'
import AppPaginacao from '@/components/AppPaginacao'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import Pesquisa from '@/components/Pesquisa'
import CONFIGS from '@/constants/configs'
import Utils from '@/utils/utils'
import TableGenerica from '@/components/TableGenerica'
import STATUS from '@/constants/statusProcessoArrecadacao'

const filtro = {
  pagina: 0,
  tamanhoPagina: CONFIGS.TAMANHO_PAGINACAO,
  withoutStatus: [
    STATUS.AGUARDANDO_GERACAO_DOCUMENTOS
  ]
}
export default {
  data () {
    return {
      colunas: [
        {
          prop: 'numeroProcesso',
          label: 'Processo',
          width: 'auto',
          formatter: Utils.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'cadastroColetivo.pecaTecnica.gleba',
          label: 'Gleba',
          width: 'auto',
          formatter: Utils.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'cadastroColetivo.pecaTecnica.municipios[0].nome',
          label: 'Município',
          width: 'auto',
          formatter: Utils.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'statusName',
          label: 'Situação',
          width: 'auto',
          formatter: Utils.formatEmptyRow,
          sortable: 'custom'
        }
      ],
      processosCadastrados: [],
      totalCadastros: 0,
      filtro,
      CONFIGS,
      Utils

    }
  },

  components: {
    AppPaginacao,
    AppDividerRefreshButton,
    Pesquisa,
    TableGenerica
  },

  computed: {
    pagina () {
      return this.filtro.pagina + 1
    }
  },

  methods: {
    sortChanged ({ column, prop, order }) {
      if (order) {
        const direcaoMap = {
          ascending: 'ASC',
          descending: 'DESC'
        }
        this.filtro.ordem = prop
        this.filtro.ordemDirecao = direcaoMap[order]
      }

      this.getProcessosCadastrados()
    },

    resetPesquisa () {
      this.filtro.pesquisaSimples = ''
      this.changePage(1)
    },

    handlePesquisa (value) {
      this.filtro.pesquisaSimples = value
      this.filtro.simplificado = true
      this.getProcessosCadastrados()
    },

    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.getProcessosCadastrados()
    },

    async analisarProcesso (processo) {
      if (processo.status === 'AGUARDANDO_ANALISE') await this.tramitarAnalisar(processo.id)
      this.$router.push({
        name: 'CAF/ANALISEPROCESSO',
        query: {
          idProcesso: processo.id
        }
      })
    },

    botoesAcao (processo) {
      if (processo.status !== 'AGUARDANDO_GERACAO_DOCUMENTOS') {
        let title = 'Iniciar análise'

        if (processo.status === STATUS.EM_ANALISE) title = 'Continuar análise'

        return [
          {
            click: this.analisarProcesso.bind(this, processo),
            icon: 'trending_up',
            title,
            active: true
          }
        ]
      }

      return [
        {
          click: null,
          icon: 'warning',
          title: 'Aguardando geração de documentos',
          active: true
        }
      ]
    },

    getProcessosCadastrados () {
      this.findProcessosCadastrados(this.filtro).then(response => {
        this.processosCadastrados = response.processosArrecadacao
        this.totalCadastros = response.total
      })
    },

    ...mapActions({
      findProcessosCadastrados: 'processoArrecadacao/find',
      tramitarAnalisar: 'processoArrecadacao/tramitarAnalisar'
    })
  },

  async created () {
    this.getProcessosCadastrados()
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/element-variables.scss';

.container {
  display: flex;
  width: 100%;
  min-height: 100%;
}
.card-container {
  border-radius: 12px;
}

.titulo {
  color: $--color-primary;
  margin-top: 3px;
}

.table {
  width: 100%;
}

.button {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/caf/CafListagem.vue